export default {
  // An object that stores a list of entities that the user has viewed
  history: {},

  // An object that stores a the user navigation
  navigationHistory: {},
};
